import { createSelector } from 'reselect';
import { State } from 'store/state';
import {
  makeNullSafeDomainGetter,
  searchAgentAwardsByDocIds,
} from 'store/state/domainData/selectors/common';
import { LeadingAgentCarouselCardData, LeadingAgentFeature } from 'utils/entities';
import { checkEnabledLeadingAgentFeature } from 'helpers/contact';


export const searchAgentAwardsByDocIdsSelector = makeNullSafeDomainGetter(searchAgentAwardsByDocIds, 'searchAwardsByDocIds');

export const leadingAgentsByDocIdsSelector = createSelector([
  searchAgentAwardsByDocIdsSelector,
  (_: State, feature: LeadingAgentFeature) => feature,
], (awards, feature): LeadingAgentCarouselCardData[] => {
  return awards ? awards.map(i => {
    const agent = i.agent;
    const isEnabled = checkEnabledLeadingAgentFeature(i, feature);
    if (!agent || !isEnabled) return null;

    return {
      officeName: agent.office && agent.office.officeName || agent.officeName,
      agentName: agent.name,
      agentLogo: agent.iconUrl,
      agentId: agent.agentId,
    };
  }).filter(Boolean) : [];
});
